export const GET_WSPOSITIONS = 'GET_WSPOSITIONS';
export const GET_WSPOSITIONS_SUCCESS = 'GET_WSPOSITIONS_SUCCESS';
export const GET_WSPOSITIONS_ERROR = 'GET_WSPOSITIONS_ERROR';
